const { styled, TextField } = require("@mui/material");

export const PostSearchBar = styled(TextField)((theme) => ({
  width: "300px",
  height: "50px",
  flex: 1,
  mr: 1,
  "& .MuiOutlinedInput-root": {
    color: "#020060",
    fontSize: "1.1rem",
    height: 56,
    borderRadius: "10px",
    fontFamily: "Poppins",
    backgroundColor: "transparent",

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    //   borderWidth: "2px",
    //   boxShadow: "0px 0px 5px 0.4px #0085FF",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    //   borderWidth: "2px",
    //   boxShadow: "0px 0px 5px 0.4px #0085FF",
    },
  },
}));

// export default NewSearchBar(){
//   return(
//      <SearchContainer>
//   <InputWrapper>
//       <img
//           src={searchIcon}
//           alt="Search Icon"
//           style={{ marginRight: '8px' }}
//       />
//       <SearchInput
//           placeholder="Search job title, company..."
//           fullWidth
//           sx={{
//               fontFamily: 'Poppins',
//               fontSize: 14,
//           }}

//       />
//   </InputWrapper>
//   {isMobile ?
//       <Divider orientation="horizontal" sx={{ height: 0, mx: 1.5, borderColor: 'divider', marginTop: 1, color: '#00000033', border: '1px solid #00000033' }} />
//       : <Divider orientation="vertical" sx={{ height: 38, mx: 1.5, borderColor: 'divider', marginTop: 1, color: '#00000033', border: '1px solid #00000033' }} />
//   }
//   <InputWrapper isSecondInput>
//       <img
//           src={locationIcon}
//           alt="Location Icon"
//           style={{ marginRight: '8px' }}
//       />
//       <SearchInput
//           placeholder=" city, Country..."
//           fullWidth
//           sx={{
//               fontFamily: 'Poppins',
//               fontSize: 14,
//           }}
//       />
//   </InputWrapper>

//   <Button
//       variant="contained"
//       sx={{
//           borderRadius: '11px',
//           px: 4,
//           backgroundColor: colors.primary,
//           textTransform: 'none',
//           fontFamily: 'Poppins',
//           fontSize: '14px',
//           [theme.breakpoints.down('md')]: {
//               width: '100%',
//               // mt: 1
//               // width: 206,
//               minHeight: '45px',
//               gap: '10px',
//               // borderRadius: '10px',
//               paddingTop: '16px',
//               paddingBottom: '16px',
//               marginTop:2,
//           }
//       }}>
//       Search
//   </Button>
// </SearchContainer>
//   )
 
// }
